import React, { useState } from 'react';
import { Spinner } from '../../../../components/spinner';
import { AutoPayTypes } from '../../AutoPayTypes';
import { autoPayPageLabels } from '../../constants/accountPanelConfigs';
import { AutoPayDisabledNotification } from '../AutoPay/AutoPayDisabledNotification';
import { AutoPayEnabled } from '../AutoPay/AutoPayEnabled';
import { AutoPayLayout } from '../AutoPay/AutoPayLayout';
import { UpdateDetailsErrorScreen } from '../ErrorScreens/UpdateDetailsErrorScreen';
import { disableAutoPayForTenant } from '@codeparva/v11-tfw-api-library';

export const AutoPayPage = ({
  tenantSearchData,
  ledgerId,
  payment_methods,
  facilityId,
  tenantToken,
}: AutoPayTypes.TAutoPayPage) => {
  const { ledger } = tenantSearchData;
  const selectedLedgerData = ledger.filter(({ id }) => id === ledgerId)[0];
  const {
    financials: { is_auto_pay_enabled = false } = {},
  } = selectedLedgerData;
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [isAutoPayEnabled, setIsAutoPayEnabled] = useState(is_auto_pay_enabled);
  const [isApiCallFinished, setIsApiCallFinished] = useState(false);
  const [autoPayAPICallRes, setAutoPayAPICallRes] = useState(false);
  const { notEnabledMessage } = autoPayPageLabels;

  const deActivateAutoPay = async () => {
    setIsLoading(true);
    const [
      err,
      { data: { success = false } = {} } = {},
    ] = await disableAutoPayForTenant({
      ledgerId,
      facilityId,
      tenantToken,
    });
    setIsLoading(false);
    setIsApiCallFinished(true);
    setAutoPayAPICallRes(success);
    if (success) {
      setIsAutoPayEnabled(false);
    }
    if (err) {
      console.error('Error in AutoPayPage', err);
      setHasError(true);
    }
  };

  const notificationButtonClickHandler = () => {
    setIsApiCallFinished(false);
  };

  const GetAutoPayComponent = () => {
    if (isAutoPayEnabled) {
      const autoPayEnabledProps = {
        deActivateAutoPay,
        selectedLedgerData,
        payment_methods,
      };
      return <AutoPayEnabled {...autoPayEnabledProps} />;
    } else {
      return (
        <div className="autoPayDisabledMessage">
          <p>{notEnabledMessage}</p>
        </div>
      );
    }
  };

  const showErrorScreen = () => {
    if (hasError) {
      return (
        <UpdateDetailsErrorScreen
          setError={setHasError}
          setLoading={setIsLoading}
        />
      );
    } else {
      return (
        <div className="loaderParent">
          <Spinner />
        </div>
      );
    }
  };

  const AutoPayComponent = () => {
    if (isLoading) {
      return <>{showErrorScreen()}</>;
    } else {
      return (
        <>
          {isApiCallFinished && (
            <AutoPayDisabledNotification
              handleClick={notificationButtonClickHandler}
              status={autoPayAPICallRes}
            />
          )}
          <AutoPayLayout>
            <GetAutoPayComponent />
          </AutoPayLayout>
        </>
      );
    }
  };

  return <AutoPayComponent />;
};
